import React, { useEffect, useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { useOrganization } from "../hooks/useOrganization";
import { organizationTheme } from "./theme";

/* public/favicon.ico is the shell's, written by npm run config; index.html
   points the tab at it before React runs. */
export const SHELL_FAVICON = `${process.env.PUBLIC_URL}/favicon.ico`;

/** Points the browser tab's icon at `href`, adding the link if there is none. */
export function showFavicon(href) {
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  if (link.getAttribute("href") !== href) link.setAttribute("href", href);
}

/**
 * The theme and tab icon of the selected organization: its palette over the
 * shell's, and its favicon or the shell's. Re-renders on a switch, in this
 * tab or another, so the bar, the buttons and the tab change together.
 */
export default function OrganizationTheme({ children }) {
  const { organization } = useOrganization();
  const theme = useMemo(() => organizationTheme(organization), [organization]);

  useEffect(() => {
    showFavicon(organization?.favicon ?? SHELL_FAVICON);
  }, [organization]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
